"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const redemptionRouter = {
  path: '/redemption',
  component: _index.default,
  redirect: 'redemption',
  name: 'Redemption',
  meta: {
    title: 'redemption.title',
    icon: 'faq'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/redemption/list.vue'))),
    name: 'Redemption',
    meta: {
      title: 'redemption.title',
      noCache: true,
      icon: 'faq'
    }
  }]
};
var _default = exports.default = redemptionRouter;